import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { isScoutJobDetailResponse } from 'pages/DodaFront/View/JobSearchDetail/utils/castJobType';
import { makeCorporateFullName } from '@doda/common/src/logics/jobSearchDetail/makeCorporateFullName';

/**
 * jobのプロパティを作成 ※毎回定義するのを避けるため。必要なプロパティがあれば、適宜追加する
 * ※求人詳細ボディで使用するプロパティ専用
 * @param {ScoutJobDetailResponse | JobDetailResponse} job 求人詳細APIの返却値かスカウト求人詳細の返却値
 * @returns {Object} - jobのプロパティ
 */
export const createJobProperty = (
  job: JobDetailResponse | ScoutJobDetailResponse
) => {
  // 変数定義
  const jid = job.job?.jid || '';
  const jobState = job.job?.recruit?.jobState || '';
  const workLocations = job.workLocations || [];
  const workTime = job.job?.recruit?.workTime || '';
  const averageOvertimeHours = job.job?.recruit?.averageOvertimeHours || '';
  const averageOvertimeHoursExplanation =
    job.job?.recruit?.averageOvertimeHoursExplanation || '';
  const formDivision = job.job?.recruit?.formDivision || '';
  const period = job.job?.recruit?.period || '';
  const access = job.job?.recruit?.access || '';
  const workTimeReason = job.job?.recruit?.workTimeReason || '';
  const jobOfferKind = job.job?.jobOfferKind || '';
  const selectionInformation = job.job?.selectionInformation || undefined;
  const movieId = job.job?.movieId || '';
  const members = (isScoutJobDetailResponse(job, true) && job?.members) || [];
  const companyInfo = job.job?.companyInfo || undefined;
  const corporateFullName = job.job ? makeCorporateFullName(job.job) : '';
  const occupationName = job.job?.occupationName || '';
  const recruit = job.job?.recruit || undefined;
  const salary = recruit?.salary || '';
  const salaryExamples = recruit?.salaryExamples || [];
  const raise = recruit?.raise || '';
  const bonus = recruit?.bonus || '';
  const treatmentAndWelfare = recruit?.treatmentAndWelfare || '';
  const companyBenefits = recruit?.companyBenefits || '';
  const holiday = recruit?.holiday || '';
  const interview = job?.job?.interview;
  const employeeInterviews =
    interview?.employeeInterviews?.filter(
      (employeeInterview) => employeeInterview?.text
    ) || [];
  const hasCompanyPageLink = job.job?.hasCompanyPageLink || false;
  const companyId = job.job?.companyId || '';
  const corporateName = job.job?.corporateName || '';
  const businessOutline = job.job?.businessOutline;
  const marketName = job.job?.marketName || '';
  const drImageList =
    (isScoutJobDetailResponse(job, true) && job.drImageList) || [];
  const picturePublicImages = job.job?.interview?.picturePublicImages || [];

  const jobContentOutline = job.job?.recruit?.jobContentOutline || '';
  const jobContentDetail = job.job?.recruit?.jobContentDetail || '';
  const teamStructure = job.job?.recruit?.teamStructure || '';
  const organizationCategory = job.job?.recruit?.organizationCategory || '';
  const genderRatio = job.job?.recruit?.genderRatio || '';
  const ageComposition = job.job?.recruit?.ageComposition || '';
  const retentionRate = job.job?.recruit?.retentionRate || '';
  const projectCase = job.job?.recruit?.projectCase || '';
  const projectCaseTitle = job.job?.recruit?.projectCaseTitle || '';
  const developmentEnvironment = job.job?.recruit?.developmentEnvironment || '';
  const developmentEnvironmentTitle =
    job.job?.recruit?.developmentEnvironmentTitle || '';
  const recruitBackGround = job.job?.recruit?.recruitBackGround || '';

  const targetMemberOutline = job.job?.recruit?.targetMemberOutline || '';
  const targetMemberDetail = job.job?.recruit?.targetMemberDetail || '';

  const freeSpaces = job.job?.recruit?.freeSpaces || [];
  const companyMessage = job.job?.companyMessage;
  const selectionPoint = job.job?.recruit?.selectionPoint || '';
  const ageLimitDisplay = job.job?.recruit?.ageLimitDisplay;
  const indicatorReason = job.job?.recruit?.indicatorReason;

  const isAgent = job.job?.selectionInformation?.isAgent || false;
  const isRead = 'isRead' in job ? job.isRead || false : false;

  const hasArticleContent = job.job?.hasArticleContent || false;

  return {
    jid,
    jobState,
    workLocations,
    workTime,
    averageOvertimeHours,
    averageOvertimeHoursExplanation,
    formDivision,
    period,
    access,
    workTimeReason,
    jobContentOutline,
    jobContentDetail,
    teamStructure,
    organizationCategory,
    genderRatio,
    ageComposition,
    retentionRate,
    projectCase,
    projectCaseTitle,
    developmentEnvironment,
    developmentEnvironmentTitle,
    targetMemberOutline,
    targetMemberDetail,
    freeSpaces,
    jobOfferKind,
    selectionInformation,
    movieId,
    members,
    companyInfo,
    corporateFullName,
    occupationName,
    recruit,
    salary,
    salaryExamples,
    raise,
    bonus,
    treatmentAndWelfare,
    companyBenefits,
    holiday,
    interview,
    employeeInterviews,
    hasCompanyPageLink,
    companyId,
    corporateName,
    businessOutline,
    marketName,
    drImageList,
    picturePublicImages,
    companyMessage,
    selectionPoint,
    ageLimitDisplay,
    indicatorReason,
    isAgent,
    recruitBackGround,
    isRead,
    hasArticleContent,
  };
};
